module.exports = __webpack_public_path__ + "static/media/message.e70f352f.png";